
import React from "react"
import { useNavigate } from 'react-router-dom'
import { useEffect } from 'react';
import { setErrorMessage } from "../tools/errorhandling";


const Cleaningtask = (props) => {
    // create navigation object if needed
    const navigate = useNavigate();
    const t = props.translation

    useEffect(() => {
        try {
            const data = async () => {
            };
            data.then(response => {
                if (response === 200) {
                    const contentdiv = document.getElementById("content")
                } else {
                    throw new Error(response.status + ":" + response.message)
                }
            })
        } catch (error) {
            setErrorMessage(error.message)
        }


    }, []);

    return (
        <>
            <div id="main">
                <header>
                    <div id="errordiv" className='error'></div>
                </header>
                <div id="content" className='formwidth'>
                    <form className="form" >
                    <label className='formtitle'>
                                {t("CleaningTask")}
                            </label>
                        <div className="formchild">
                            <label className='labelhotel'>
                                {t("ID")}:
                            </label>
                            <input className="normalinput" type='text'  ></input>
                            </div>
                        <div className="formchild">
                            <label className='labelhotel'>
                                {t("Name")}:
                            </label>
                            <input className="normalinput" type='text'  ></input>
                        </div>
                        <div className="formchild">
                            <label className='labelhotel'>
                                {t("Description")}:
                            </label>
                            <textarea name="message" className="textarea doublegrid"></textarea>
                        </div>
                        <div className="formchild">
                            <label className='labelhotel'>
                                {t("Duration")}:
                            </label>
                            <input className="normalinput" type='text'  ></input>
                        </div>
                    </form>
                </div>
            </div>
        </>
    )

}

export default Cleaningtask